import { render } from "./gameReportNext.vue?vue&type=template&id=35af5015&scoped=true"
import script from "./gameReportNext.vue?vue&type=script&lang=js"
export * from "./gameReportNext.vue?vue&type=script&lang=js"

import "./gameReportNext.vue?vue&type=style&index=0&id=35af5015&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35af5015"]])

export default __exports__